import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import SettlementRed from '@static/images/settlement_red.svg'
import SettlementBlue from '@static/images/settlement_blue.svg'
import SettlementOrange from '@static/images/settlement_orange.svg'
import SettlementGreen from '@static/images/settlement_green.svg'
import SettlementBlack from '@static/images/settlement_black.svg'
import SettlementBronze from '@static/images/settlement_bronze.svg'
import SettlementSilver from '@static/images/settlement_silver.svg'
import SettlementGold from '@static/images/settlement_gold.svg'
import SettlementWhite from '@static/images/settlement_white.svg'
import SettlementPurple from '@static/images/settlement_purple.svg'
import SettlementMysticBlue from '@static/images/settlement_mysticblue.svg'
import SettlementPink from '@static/images/settlement_pink.svg'

export const SETTLEMENT_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: SettlementRed,
    [PlayerColor.Blue]: SettlementBlue,
    [PlayerColor.Orange]: SettlementOrange,
    [PlayerColor.Green]: SettlementGreen,
    [PlayerColor.Black]: SettlementBlack,
    [PlayerColor.Bronze]: SettlementBronze,
    [PlayerColor.Silver]: SettlementSilver,
    [PlayerColor.Gold]: SettlementGold,
    [PlayerColor.White]: SettlementWhite,
    [PlayerColor.Purple]: SettlementPurple,
    [PlayerColor.MysticBlue]: SettlementMysticBlue,
    [PlayerColor.Pink]: SettlementPink,
}
